// extracted by mini-css-extract-plugin
export default {"labelRadio":"style_labelRadio__avZrH","labelRadioPayment":"style_labelRadioPayment__epFO+"};